'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YesButton = exports.NoButton = exports.CancelButton = exports.OkButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _cleanProps = require('../../common/cleanProps');

var _cleanProps2 = _interopRequireDefault(_cleanProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propsToRemove = {
  buttonLabel: true
};

var OkButton = function OkButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({ theme: 'default' }, (0, _cleanProps2.default)(props, propsToRemove)),
    props.buttonLabel || 'Ok'
  );
};

var CancelButton = function CancelButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({ theme: 'light' }, (0, _cleanProps2.default)(props, propsToRemove)),
    props.buttonLabel || 'Cancel'
  );
};

var NoButton = function NoButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({ theme: 'default' }, (0, _cleanProps2.default)(props, propsToRemove)),
    props.buttonLabel || 'No'
  );
};

var YesButton = function YesButton(props) {
  return _react2.default.createElement(
    _Button2.default,
    _extends({ theme: 'default' }, (0, _cleanProps2.default)(props, propsToRemove)),
    props.buttonLabel || 'Yes'
  );
};

exports.OkButton = OkButton;
exports.CancelButton = CancelButton;
exports.NoButton = NoButton;
exports.YesButton = YesButton;